import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-view-state',
  imports: [],
  templateUrl: './view-state.component.html',
  styleUrl: './view-state.component.scss',
})
export class ViewStateComponent {
  @Input() status!: 'loading' | 'error';
  @Input() title!: string;
  @Input() subtitle!: string;
}
